export const isWithinIframe = () => {
  return window.location !== window.parent.location;
};
